function micromodalInit() {
	MicroModal.init();

	// for test
	// MicroModal.show('modal__confirmationEmail');

	var closeFormTrigger = $(".closeFormTrigger");
	var formBody = $(".modal");

	closeFormTrigger.on("click", function(event) {
		event.preventDefault();
		formBody.removeClass("is-open");
	});
}

$(".modalForm--forgot").submit(function(e) {
	var form = this;
	e.preventDefault();
	$(".modalCallback--forgot").addClass("submitted");
	setTimeout(function() {
		form.submit();
	}, 3000);
});

// ---DEV--- start
$(".modalForm--chooseType").submit(function(e) {
	var form = this;
	e.preventDefault();
	$.ajax({
		type: "POST",
		url: "/request/set-account-type",
		data: $(form).serialize(),
		success: function(result) {
			$(".modal").removeClass("is-open");
			MicroModal.show("modal__signup");
		}
	});
});
// ---DEV--- end

// temporary version CHOOSE TYPE for html subdomain only - start
// $('.modalForm--chooseType').submit(function(e) {
// 	var form = this;
// 	e.preventDefault();
// 	$('.modal').removeClass("is-open")
// 	MicroModal.show('modal__signup');
// });
// temporary version CHOOSE TYPE for html subdomain only - end

// temporary version for POST COMMENT html subdomain only - start
// $('.modalForm--postComment').submit(function(e) {
// 	var form = this;
// 	e.preventDefault();
// 	$('.modal').removeClass("is-open")
// 	MicroModal.show('modal__postSubmitted');
// });
// temporary version for POST COMMENT html subdomain only - end